<template>
    <div @click="closeDropdowns">
      <div class="dropdowns">
        <div class="dropdown" :class="{ 'is-active': isEstablishmentActive }" @click.stop="toggleDropdown('establishment')">
          <div class="dropdown-trigger">
            <button class="btn btn-outline-primary" aria-haspopup="true" aria-controls="dropdown-menu-establishment">
              <span>{{selected_establishment_uid? selected_establishment_name: "Établissements" }}</span>
              <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu-establishment" role="menu">
            <div class="dropdown-content scrollable-dropdown" style="border-radius: none; box-shadow: none;">
              <a href="#" class="dropdown-item" @click="filter_establishment(null)">
                Aucun
              </a>
              <a v-for="establishment in establishments" :key="establishment.uid" href="#" class="dropdown-item" @click="filter_establishment(establishment.uid)">
                {{ establishment.name }}
              </a>
            </div>
          </div>
        </div>
  
        <div class="dropdown" :class="{ 'is-active': isEstablishmentTypeActive }" @click.stop="toggleDropdown('establishmentType')">
          <div class="dropdown-trigger">
            <button class="btn btn-outline-primary" aria-haspopup="true" aria-controls="dropdown-menu-establishment-type">
              <span>{{selected_establishment_type? selected_establishment_type: "Type d'Établissements"}}</span>
              <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu-establishment-type" role="menu">
            <div class="dropdown-content" style="border-radius: none; box-shadow: none;">
              <a href="#" class="dropdown-item" @click="filter_establishment_type(null)">
                Aucun
              </a>
              <a v-for="establishment_type in establishment_types_list" :key="establishment_type.name" href="#" class="dropdown-item" @click="filter_establishment_type(establishment_type.name)">
                {{ establishment_type.name }}
              </a>
            </div>
          </div>
        </div>
  
        <div class="dropdown" :class="{ 'is-active': isPlatformActive }" @click.stop="toggleDropdown('platform')">
          <div class="dropdown-trigger">
            <button class="btn btn-outline-primary" aria-haspopup="true" aria-controls="dropdown-menu-platform">
              <span>{{selected_platform_uid? selected_plaform_name: "Plateforme" }}</span>
              <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu-platform" role="menu">
            <div class="dropdown-content scrollable-dropdown" style="border-radius: none; box-shadow: none;">
              <a href="#" class="dropdown-item" @click="filter_platform(null)">
                Aucun
              </a>
              <a v-for="platform in platforms_list" :key="platform.uid" href="#" class="dropdown-item" @click="filter_platform(platform.uid)">
                {{ platform.name }}
              </a>
            </div>
          </div>
        </div>
  
        <div class="dropdown" :class="{ 'is-active': isSentimentActive }" @click.stop="toggleDropdown('sentiment')">
          <div class="dropdown-trigger">
            <button class="btn btn-outline-primary" aria-haspopup="true" aria-controls="dropdown-menu-sentiment">
              <span>{{selected_sentiment? selected_sentiment: "Sentiment" }}</span>
              <span class="icon is-small">
                <i class="fas fa-angle-down" aria-hidden="true"></i>
              </span>
            </button>
          </div>
          <div class="dropdown-menu" id="dropdown-menu-sentiment" role="menu">
            <div class="dropdown-content" style="border-radius: none; box-shadow: none;">
              <a href="#" class="dropdown-item" @click="filter_sentiment(null)">Aucun</a>
              <a href="#" class="dropdown-item" @click="filter_sentiment('positif')">Positif</a>
              <a href="#" class="dropdown-item" @click="filter_sentiment('negatif')">Négatif</a>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!fetching_assistants">
        <table class="table is-striped is-fullwidth leaderboard-table">
          <thead>
            <tr>
              <th @click="sortTable('name')">Nom</th>
              <th @click="sortTable('elo_score')">Score ELO</th>
              <th @click="sortTable('is_active')">Status</th>
              <th @click="sortTable('_llm_name')">LLM</th>
              <th @click="sortTable('_temperature')">Température</th>
              <th @click="sortTable('specialist_sentiment')">Spécialité Sentiment</th>
              <th @click="sortTable('specialist_platform')">Spécialité plateforme</th>
              <th>Actions</th>
              <!-- <th></th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="assistant in sorted_assistants" :key="assistant.name" >
              <td><strong>{{ assistant.name }}</strong></td>
              <td>
                <span v-if="computing_elos">
                  <i class="fas fa-spinner fa-spin" aria-hidden="true"></i>
                </span>
                <span v-else>
                  <span class="tag is-primary"  v-if="assistant.elo_score">
                    <strong style="color: black;">{{assistant.elo_score}}</strong></span>
                  <span class="tag is-warning" v-else>Pas de parties</span>
                </span>
              </td>
              <td>
                <span class="tags">
                  <span class="tag is-success" v-if="assistant.is_active">activé</span>
                  <span class="tag is-warning" v-if="!assistant.is_active">désactivé</span>
                </span>
              </td>
              <td>
                <span>{{ assistant.step_set[0].llm_name }}</span>
              </td>
              <td>{{ assistant.step_set[0].temperature }}</td>
              <td>{{ assistant.specialist_sentiment? assistant.specialist_sentiment: "aucune"  }}</td>
              <td>{{ assistant.specialist_platform? assistant.specialist_platform.name: "aucune" }}</td>
              <td>
                <div class="d-flex gap-2 justify-content-between align-items-center">
                  <button class="btn btn-outline-primary btn-sm me-2 py-0" style="height: 22px;" @click="select_assistant(assistant)">Infos</button>
                  <button class="btn btn-primary btn-sm py-0" style="height: 22px;" @click="show_details(assistant.uid)">Aller au détail</button>
                </div>
              </td>
              <!-- <td>{{ assistant.rank}}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
      <div class="content" v-else>
        <h5>
          <div class="icon">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <span>Chargement des assistants...</span>
        </h5>
      </div>
  
      <div v-if="show_assistant_detail" class="modal">
        <div class="modal-content">
          <div class="block content">
            <span class="close is-right" @click="selectedAssistant = null; show_assistant_detail=false">&times;</span>
            <h4>{{ selectedAssistant.name }}</h4>
          </div>

          <div class="block">
            <div class="tags">
              <span class="tag is-primary">LLM: {{ selectedAssistant.step_set[0].llm_name }}</span>
              <span class="tag">Température: {{ selectedAssistant.step_set[0].temperature }}</span>
              <span class="tag">Max Tokens: {{ selectedAssistant.step_set[0].max_output_tokens }}</span>
            </div>
          </div>
          <div class="block content">
              <h5>Prompt</h5>
              <textarea class="textarea" name="" id="" cols="30" rows="10" disabled v-model="selectedAssistant.step_set[0].prompt"></textarea>
          </div>
          <div class="block">
            <button class="btn btn-primary" @click="show_details(selectedAssistant.uid)">Aller au détail</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import gql from '@/gqlService';
  import query from '@/gql/queries';
  
  export default {
    data() {
      return {
        data: [
          { name: 'John Doe', age: 28, email: 'john@example.com' },
          { name: 'Jane Smith', age: 34, email: 'jane@example.com' },
          { name: 'Sam Johnson', age: 45, email: 'sam@example.com' }
        ],
        currentSort: 'elo_score',
        currentSortDir: 'desc',
        assistants: [],
        platforms_list: [],
        establishment_types_list: [],
        selected_establishment_type: null,
        selectedAssistant: null,
        isEstablishmentActive: false,
        isEstablishmentTypeActive: false,
        isPlatformActive: false,
        isSentimentActive: false,
        show_assistant_detail: false,
        fetching_assistants: false,
        computing_elos: false,
        selected_platform_uid: null,
        selected_plaform_name: null,
        selected_sentiment: null,
        selected_establishment_uid: null,
        selected_establishment_name: null,
        establishment_set: new gql.DataHolder({
            "model": "establishment_set",
            "fields": "uid name logo",
            "autoload": this.autoload,
            "filters": {active:true}
        }),
        establishments: [],
      };
    },
    computed: {
      sorted_assistants() {
        return this.assistants.slice().sort((a, b) => {
          let modifier = 1;
          if (this.currentSortDir === 'desc') modifier = -1;

          if (a[this.currentSort] === null && b[this.currentSort] !== null) return -1 * modifier;
          if (a[this.currentSort] !== null && b[this.currentSort] === null) return 1 * modifier;
          if (a[this.currentSort] === null && b[this.currentSort] === null) return 0;

          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
          return 0;
        });
      }
    },
    async created() {
      await this.fetch_data();
      document.addEventListener('click', this.closeDropdowns);
    },
    beforeDestroy() {
      document.removeEventListener('click', this.closeDropdowns);
    },
    methods: {  
      sortTable(column) {
        if (this.currentSort === column) {
          this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
        } else {
          this.currentSort = column;
          this.currentSortDir = 'asc';
        }
      },
      async show_details(uid){
        await this.$store.commit("select_assistant", {assistant_uid: uid})
        this.$emit("redirect_assistant_detail", uid)
      },
      compute_ranks() {
        this.assistants.sort((a, b) => {
            var modifier = -1
            if (a.elo_score === null && b.elo_score !== null) return -1 * modifier;
            if (a.elo_score !== null && b.elo_score === null) return 1 * modifier;
            if (a.elo_score === null && b.elo_score === null) return 0;
            if (a.elo_score < b.elo_score) return -1 * modifier;
            if (a.elo_score > b.elo_score) return 1 * modifier;
            return 0;
          });
          // Step 2: Add a rank attribute to each object
          this.assistants.forEach((a, index) => {
            a.rank = index + 1;
            if (a.rank === 1) a.rank = "🥇"
            if (a.rank === 2) a.rank = "🥈"
            if (a.rank === 3) a.rank = "🥉"


            a.n_steps = a.step_set.length
          });
      },
      async fetch_data() {
        this.fetching_assistants = true;
        try {
          const resp = await query.run_v2('assistants');  
          this.assistants = resp.body.data.assistants;
          this.assistants.forEach((a, index) => a.n_steps = a.step_set.length)
          // add extra values for sorting
          this.assistants.forEach((a, index) => a._llm_name = a.step_set[0].llm_name)
          this.assistants.forEach((a, index) => a._temperature = a.step_set[0].temperature)

          // Step 1: Sort the array based on the score_elo attribute in descending order, treating null as the lowest score
            this.sortBy("created_on");
          this.fetching_assistants = false;
        } catch (error) {
          console.error('Error fetching data:', error);
        }
        try {
          const resp = await query.run('get_platform_set');
          this.platforms_list = resp.body.data.platform_set;
        } catch (error) {
          console.error('Error fetching data:', error);
        }
        try {

        } catch (error) {
          console.error("Error fetching default_prompt", error)
        }
        try {
          this.establishment_set.promise.then(()=>{
            this.establishments = this.establishment_set.results
          });
        }
        catch (error) {
          console.error("Error fetching establishments", error)
        }
        try {
          const resp = await query.run('get_establishment_types')
          this.establishment_types_list = resp.body.data.establishment_types
        }
        catch (error) {
          console.error("Error fetching establishments types", error)
        }
        
      },
      async filter_establishment(establishment_id) {
        this.computing_elos = true;
        if (establishment_id !== null){
          this.selected_establishment_uid = establishment_id
          const selected_establishment = this.establishments.filter(e => e.uid == this.selected_establishment_uid)[0]
          this.selected_establishment_name = selected_establishment.name
          const resp = await query.run_v2('assistants', {"sentiment": this.selected_sentiment, "establishment_type": this.selected_establishment_type, "platform_id": this.selected_platform_uid, "establishment_id": this.selected_establishment_uid});
          this.assistants = resp.body.data.assistants;
          this.assistants.forEach((a) => a.n_steps = a.step_set.length)
        } else {
          // load all assistants
          this.selected_establishment_uid = null
          this.selected_establishment_name = null
          const resp = await query.run_v2('assistants');  
          this.assistants = resp.body.data.assistants;
        }
        this.computing_elos = false;
        this.closeDropdowns();
      },
      async filter_establishment_type(type) {
        this.computing_elos = true;
        if (type !== null){
          this.selected_establishment_type = type
          const resp = await query.run_v2('assistants', {"sentiment": this.selected_sentiment, "establishment_type": this.selected_establishment_type, "platform_id": this.selected_platform_uid, "establishment_id": this.selected_establishment_uid});
          this.assistants = resp.body.data.assistants;
          this.assistants.forEach((a) => a.n_steps = a.step_set.length)
          // Logique de filtrage
        } else {
          this.selected_establishment_type = null
          const resp = await query.run_v2('assistants');  
          this.assistants = resp.body.data.assistants;
        }
        this.computing_elos = false;
        this.closeDropdowns();
      },
      async filter_platform(platform_uid) {
        this.computing_elos = true;
        if (platform_uid !== null){
          // Logique de filtrage
          this.selected_platform_uid = platform_uid
          this.selected_plaform_name = this.platforms_list.filter(p => p.uid == this.selected_platform_uid)[0].name
          const resp = await query.run_v2('assistants', {"sentiment": this.selected_sentiment, "establishment_type": this.selected_establishment_type, "platform_id": this.selected_platform_uid, "establishment_id": this.selected_establishment_uid});
          this.assistants = resp.body.data.assistants;
          this.assistants.forEach((a) => a.n_steps = a.step_set.length)
        } else {
          this.selected_platform_uid = null
          this.selected_plaform_name = null
          const resp = await query.run_v2('assistants');  
          this.assistants = resp.body.data.assistants;
        }
        this.computing_elos = false;
        this.closeDropdowns();
      },
      async filter_sentiment(sentiment) {
        this.computing_elos = true;
        if (sentiment !== null){
          this.selected_sentiment = sentiment
          const resp = await query.run_v2('assistants', {"sentiment": this.selected_sentiment, "establishment_type": this.selected_establishment_type, "platform_id": this.selected_platform_uid, "establishment_id": this.selected_establishment_uid});
          this.assistants = resp.body.data.assistants;
          this.assistants.forEach((a) => a.n_steps = a.step_set.length)
        } else {
          this.selected_sentiment = null
          const resp = await query.run_v2('assistants');  
          this.assistants = resp.body.data.assistants;
        }
        this.computing_elos = false;
        this.closeDropdowns();
      },
      async select_assistant(assistant) {
        this.selectedAssistant = {}
        const resp = await query.run_v2('assistants', {"uid": assistant.uid});

        this.selectedAssistant = resp.body.data.assistants[0];
        this.show_assistant_detail = true

      },
      sortBy(property) {
        this.assistants.sort((a, b) => {
          if (a[property] > b[property]) {
            return 1;
          } else if (a[property] < b[property]) {
            return -1;
          }
          return 0;
        });
      },
      toggleDropdown(type) {
        this.closeDropdowns()
        this[`is${type.charAt(0).toUpperCase() + type.slice(1)}Active`] = !this[`is${type.charAt(0).toUpperCase() + type.slice(1)}Active`];
      },
      closeDropdowns() {
        this.isEstablishmentActive = false;
        this.isEstablishmentTypeActive = false;
        this.isPlatformActive = false;
        this.isSentimentActive = false;
      }
    },
  };
  </script>
  
  <style scoped>
  .dropdowns {
    display: flex;
    gap: 1rem;
    margin-bottom: 1rem;
  }
  
  .leaderboard-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  th {
    background-color: #f4f4f4;
  }
  
  tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  tr:hover {
    background-color: #e2e2e2;
    cursor: pointer;
  }
  
  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
    max-width: 600px;
    border-radius: 10px;
  }
  
  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  
  .card {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
  
  .card-content {
    padding: 1rem;
    background-color: #f9f9f9;
    border-bottom: 1px solid #ddd;
  }
  
  .card-content h3 {
    margin-top: 0;
  }
  
  /* Add styles for scrollable dropdown */
  .scrollable-dropdown {
    max-height: 200px; /* Adjust as needed */
    overflow-y: auto;
  }
  </style>
  
